import { Box } from '@mui/material';
// @mui
import { useTheme } from '@mui/material/styles';
import { forwardRef } from 'react';

import type { LabelProps } from './types';

//
import { StyledLabel } from './styles';

// ----------------------------------------------------------------------

const Label = forwardRef<HTMLSpanElement, LabelProps>(
  (
    {
      children,
      color = 'default',
      endIcon,
      startIcon,
      sx,
      variant = 'soft',
      ...other
    },
    ref
  ) => {
    const theme = useTheme();

    const iconStyle = {
      '& svg, img': { height: 1, objectFit: 'cover', width: 1 },
      height: 16,
      width: 16,
    };

    return (
      <StyledLabel
        component="span"
        ownerState={{ color, variant }}
        ref={ref}
        sx={{
          ...(startIcon && { pl: 0.75 }),
          ...(endIcon && { pr: 0.75 }),
          ...sx,
        }}
        theme={theme}
        {...other}
      >
        {startIcon && <Box sx={{ mr: 0.75, ...iconStyle }}> {startIcon} </Box>}

        {children}

        {endIcon && <Box sx={{ ml: 0.75, ...iconStyle }}> {endIcon} </Box>}
      </StyledLabel>
    );
  }
);

Label.displayName = 'Label';

export default Label;
